import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils/utils';

const Checkbox = forwardRef(
  ({ className, onChange, onCheckedChange, ...props }, ref) => {
    const handleChange = (event) => {
      onChange?.(event);
      onCheckedChange?.(event.target.checked);
    };

  return (
    <input
      type='checkbox'
      ref={ref}
      onChange={handleChange}
      className={cn(
        'h-4 w-4 cursor-pointer rounded border-gray-300 accent-primary text-primary focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
  },
);

Checkbox.displayName = 'Checkbox';

export { Checkbox };
